export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-solid-900.woff2?9451d5fee89b51a20f8a44c56a4f6c1a";